export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const globalStore = useGlobalStore();

  // if (process.env.NODE_ENV === 'production' || config.public.env === 'stag') {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", config.public.CLARITY_PROJECT_ID);

    if (globalStore.$state.authInfo?.teamMember?.encrypted_id) {
      window.clarity('set', 'user_id', globalStore.$state.authInfo?.teamMember?.encrypted_id);
      window.clarity('set', 'account_email', globalStore.$state.authInfo?.account?.Email);
      window.clarity('set', 'team_name', globalStore.$state.authInfo?.team?.name);
      window.clarity('set', 'member_role', globalStore.$state.authInfo?.memberRole);
    }
  // }
});